<template>
    <a v-if="element" :href="result" class="def-scroll-to" @click.prevent="scrollTo">
        <span>{{ message }}</span>
    </a>
</template>

<script>
export default {
    name: 'DefScrollTo',
    selector: '.def-scroll-to',
    props: {
        'result': {
            type: String,
        },
        'message': {
            type: String,
        },
        'offsetTop': {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            element: null,
        }
    },
    methods: {
        scrollTo(e) {
            const offsetTop = $(`[data-scroll-id=${ this.result }]`).offset().top;
            let margin = this.screenWidth > 768 ? 150 : 100;
            let scroll = this.screenWidth < 993 ? offsetTop - margin : offsetTop;

            $('html, body').animate({
                scrollTop: scroll - this.offsetTop,
            }, 500);
            this.$emit('click', e);
        },
    },
    mounted() {
        this.element = document.querySelector(`[data-scroll-id='${ this.result }']`);
    }
}
</script>

<style lang="scss" scoped>
.def-scroll-to{
    color: #7b7c7e;
}
</style>